import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";

import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import InboxIcon from "@mui/icons-material/MoveToInbox";

import { GrSearch } from "react-icons/gr";

// useContext for navbar
import { useNavbar } from "../../context/NavBarContext";
// styles
import styles from "./Navbar.module.css";
import { useNavigate, useLocation } from "react-router-dom";

/*** Sidebar List ***/
import { SideBarList } from "../../utlis/sideBar";

export default function NavBar() {
  const Navbar = useNavbar();
  const location = useLocation();
  const navigate = useNavigate();

  const [state, setState] = React.useState(false);

  const handleGoBack = () => {
    navigate(-1);
  };

  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setState(open);
  };

  const handleSearch = () => {
    if (location.pathname.includes("audio")) {
      navigate("/audio/search");
    } else {
      navigate("/music/search");
    }
  };

  const renderListItem = (item, index) => (
    <List key={index}>
      <ListItem disablePadding>
        <ListItemButton
          onClick={() => (item.link != null ? navigate(item.link) : "")}
        >
          {item.icon != null && (
            // <ListItemIcon>
              <item.icon className="mx-3 text-yellow-300" />
            // </ListItemIcon>
          )}
          <ListItemText
            sx={{ color: item.colorCode ? item.colorCode : "white", "& .MuiTypography-root": {
              fontSize: "0.9rem",
            }, }}
            primary={item.title}
          />
        </ListItemButton>
      </ListItem>
    </List>
  );

  const renderNestedList = (children) =>
    children.map((child, index) => renderListItem(child, index));

  const renderList = (list) => (
    <React.Fragment key={list.title}>
      {renderListItem(list)}
      {list.children && renderNestedList(list.children)}
      <Divider variant="middle" sx={{ backgroundColor: "#52525b"}} />
    </React.Fragment>
  );

  return (
    <Box position="sticky" sx={{ flexGrow: 1 }} zIndex={10}>
      <AppBar className={`${styles.rootContainer} fixed`}>
        <Toolbar variant="dense">
          {Navbar.togglePosition == null ? (
            <IconButton
              edge="start"
              color="inherit"
              aria-label="menu"
              sx={{ mr: 2 }}
              onClick={toggleDrawer("left", true)}
              style={{ color: "#eab308" }}
            >
              <MenuIcon fontSize="20" />
            </IconButton>
          ) : (
            <IconButton
              edge="start"
              color="inherit"
              aria-label="menu"
              sx={{ mr: 2 }}
              onClick={handleGoBack}
            >
              {Navbar.togglePosition}
            </IconButton>
          )}
          <Typography variant="h6" color="inherit" component="div">
            {Navbar.logoPosition == null ? (
              <img src="./snslogo.png" alt="logo" width={80} height={30} />
            ) : (
              <Typography variant="body1" color="inherit">
                {Navbar.logoPosition}
              </Typography>
            )}
          </Typography>
          {/* {!location.pathname.includes("audio") && !location.pathname.includes("account") && ( */}
            <Box
              sx={{
                marginLeft: "auto",
                cursor: "pointer", // Add cursor pointer on hover
                "&:hover": {
                  color: "primary.main", // Change text color on hover
                },
              }}
              onClick={handleSearch}
            >
              <Typography variant="h6" color="inherit" component="div">
                <Typography variant="body4" color="inherit">
                  <GrSearch className="text-amber-300" fontSize="25" />
                </Typography>
              </Typography>
            </Box>
          {/* )} */}
        </Toolbar>
      </AppBar>
      <Drawer
        anchor={"left"}
        open={state}
        onClose={toggleDrawer("left", false)}
        PaperProps={{
          sx: {
            backgroundColor: "#27272a", // Set background color here
            width: 250,
            minHeight: "100%",
            display: "flex",
            flexDirection: "column",
          },
        }}
      >
        <Box
          sx={{
            width: 250,
            minHeight: "100%",
          }}
          role="presentation"
          onClick={toggleDrawer("left", false)}
          onKeyDown={toggleDrawer("left", false)}
        >
          {/* <img
            src="./SNS_GOLD.png"
            alt="logo"
            className="w-full"
            style={{ backgroundColor: "#27272a" }}
          /> */}
          <Divider variant="middle" sx={{ backgroundColor: "#52525b" }} />
          {SideBarList.map((list) => renderList(list))}
        </Box>
      </Drawer>
    </Box>
  );
}
